// export const SOCKETURL = `https://backend.thedresscode.studio/`;
// export const SERVERURL = `http://localhost:5000/api`;
// export const SERVERURL = `https://chaufer-backend-production.up.railway.app/api`;
// export const SERVERURL = `https://indigo-katydid-sock.cyclic.app/api`;
export const SERVERURL = `https://chaufer-backend-production.up.railway.app/api`